<template>
  <ContentWrap>
    <el-alert
      class="mb-16px"
      type="warning"
      :closable="false"
      title="联调工具 · 模拟造单。fee 外部主权。跑腿须填地址与清单/物品。【最常见空大厅原因】造单城市 ≠ 骑手登录城市；或骑手是机构骑/未上线；或策略选了机构派单却去抢单大厅看。"
    />
    <el-alert
      class="mb-16px"
      type="success"
      :closable="false"
      :title="verifyHint"
    />

    <el-form :model="form" label-width="110px" class="mb-16px max-w-720px">
      <el-form-item label="城市" required>
        <el-select v-model="form.city" placeholder="选择城市" class="!w-240px">
          <el-option label="南京" value="南京" />
          <el-option label="杭州" value="杭州" />
          <el-option label="上海" value="上海" />
          <el-option label="深圳" value="深圳" />
        </el-select>
      </el-form-item>
      <el-form-item label="获单策略" required>
        <el-radio-group v-model="form.strategy">
          <el-radio value="free_pool">自由抢单池</el-radio>
          <el-radio value="org_dispatch">机构派单</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.strategy === 'org_dispatch'" label="机构 ID" required>
        <el-input v-model="form.orgId" placeholder="须为已开通机构" class="!w-240px" />
      </el-form-item>
      <el-form-item label="运费 fee" required>
        <el-input-number v-model="form.fee" :min="0.01" :precision="2" :step="1" />
        <span class="ml-8px text-13px text-[var(--el-text-color-secondary)]">外部主权 · 不造货款</span>
      </el-form-item>
      <el-form-item label="品类">
        <el-select v-model="form.bizType" class="!w-240px" @change="onBizChange">
          <el-option label="帮我买" value="errand_buy" />
          <el-option label="帮我送" value="errand_send" />
          <el-option label="餐饮" value="food" />
          <el-option label="商超" value="grocery" />
          <el-option label="同城快递" value="express" />
        </el-select>
      </el-form-item>
      <el-form-item :label="pickTitleLabel">
        <el-input v-model="form.pickTitle" class="!w-360px" />
      </el-form-item>
      <el-form-item :label="pickAddrLabel">
        <el-input v-model="form.pickAddr" class="!w-360px" placeholder="详细地址" />
      </el-form-item>
      <el-form-item label="送点标题">
        <el-input v-model="form.dropTitle" class="!w-360px" />
      </el-form-item>
      <el-form-item label="送点地址">
        <el-input v-model="form.dropAddr" class="!w-360px" placeholder="详细地址" />
      </el-form-item>
      <el-form-item v-if="isErrand" :label="remarkLabel">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          maxlength="500"
          show-word-limit
          class="!w-360px"
          :placeholder="remarkPlaceholder"
        />
      </el-form-item>
      <el-form-item v-if="isErrand" label="坐标(可选)">
        <div class="flex flex-wrap gap-8px items-center">
          <span class="text-13px text-[var(--el-text-color-secondary)]">取</span>
          <el-input-number v-model="form.pickLat" :precision="6" :step="0.01" controls-position="right" class="!w-140px" />
          <el-input-number v-model="form.pickLng" :precision="6" :step="0.01" controls-position="right" class="!w-140px" />
          <span class="text-13px text-[var(--el-text-color-secondary)]">送</span>
          <el-input-number v-model="form.dropLat" :precision="6" :step="0.01" controls-position="right" class="!w-140px" />
          <el-input-number v-model="form.dropLng" :precision="6" :step="0.01" controls-position="right" class="!w-140px" />
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="submitting" @click="onCreate">模拟造单</el-button>
        <el-button v-if="isErrand" @click="fillExample">填入示例</el-button>
        <el-button @click="loadList">刷新本页列表</el-button>
        <el-button link type="primary" @click="goInspect">去运单巡检</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" border stripe>
      <el-table-column prop="waybillId" label="运单号" min-width="160" />
      <el-table-column label="品类" width="110">
        <template #default="{ row }">{{ bizTypeLabel(row.bizType) }}</template>
      </el-table-column>
      <el-table-column prop="city" label="城市" width="90" />
      <el-table-column label="策略" width="120" align="center">
        <template #default="{ row }">{{ waybillStrategyLabel(row.strategy) }}</template>
      </el-table-column>
      <el-table-column label="运费" width="90" align="right">
        <template #default="{ row }">{{ formatMoneyAmount(row.fee, row.currency) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template #default="{ row }">{{ waybillStatusLabel(row.status, row.bizType) }}</template>
      </el-table-column>
      <el-table-column prop="pickTitle" label="取/购" min-width="100" />
      <el-table-column prop="pickAddr" label="取址" min-width="120" show-overflow-tooltip />
      <el-table-column prop="dropTitle" label="送点" min-width="100" />
      <el-table-column prop="remark" label="清单/物品" min-width="140" show-overflow-tooltip />
      <el-table-column prop="riderPhone" label="骑手" width="120" />
      <el-table-column label="创建时间" min-width="160">
        <template #default="{ row }">{{ formatCapacityDateTime(row.createdAt) }}</template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="total"
      v-model:page="pageNo"
      v-model:limit="pageSize"
      @pagination="loadList"
    />
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as WaybillApi from '@/api/capacity/waybill'
import {
  formatCapacityDateTime,
  formatMoneyAmount,
  waybillStatusLabel,
  waybillStrategyLabel
} from '@/api/capacity/labels'
import { ContentWrap } from '@/components/ContentWrap'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'

defineOptions({ name: 'CapacityMockWaybill' })

const router = useRouter()

const form = reactive({
  city: '杭州',
  strategy: 'free_pool' as 'free_pool' | 'org_dispatch',
  orgId: '',
  fee: 12,
  bizType: 'errand_send',
  pickTitle: '联调取件点',
  pickAddr: '西湖区文三路 1 号',
  pickLat: 30.27 as number | undefined,
  pickLng: 120.15 as number | undefined,
  dropTitle: '用户住址',
  dropAddr: '西湖区文一路 100 号',
  dropLat: 30.28 as number | undefined,
  dropLng: 120.16 as number | undefined,
  remark: '文件袋 1 份，勿压',
  etaMinutes: 40
})

const list = ref<WaybillApi.CapacityWaybillItem[]>([])
const pageNo = ref(1)
const pageSize = ref(10)
const total = ref(0)
const submitting = ref(false)
const lastStrategy = ref<string>('free_pool')
let disposed = false

const BIZ_LABEL: Record<string, string> = {
  food: '餐饮',
  city_delivery: '同城配送',
  express: '快递',
  fresh: '生鲜',
  pharmacy: '医药',
  grocery: '商超',
  errand_buy: '帮我买',
  errand_send: '帮我送'
}

function bizTypeLabel(bizType?: string) {
  if (!bizType) return '—'
  const key = bizType.toLowerCase()
  return BIZ_LABEL[key] || bizType
}

const isErrand = computed(
  () => form.bizType === 'errand_buy' || form.bizType === 'errand_send'
)
const pickTitleLabel = computed(() => (form.bizType === 'errand_buy' ? '购买点标题' : '取点标题'))
const pickAddrLabel = computed(() => (form.bizType === 'errand_buy' ? '购买点地址' : '取点地址'))
const remarkLabel = computed(() => (form.bizType === 'errand_buy' ? '购物清单' : '物品描述'))
const remarkPlaceholder = computed(() =>
  form.bizType === 'errand_buy' ? '如：矿泉水 2 箱；纸巾 1 提' : '如：文件袋 1 份，勿压'
)

const verifyHint = computed(() => {
  const cityTip = `造单城市「${form.city}」须与骑手登录城市一致，否则大厅为空。`
  if (lastStrategy.value === 'org_dispatch') {
    return `${cityTip} 机构派单：机构端派单后机构骑才能接，自由骑抢单大厅看不到。`
  }
  return `${cityTip} 自由池：仅「自由骑 + 已上线」能在抢单大厅看到。`
})

const onBizChange = () => {
  if (form.bizType === 'errand_buy' || form.bizType === 'errand_send') {
    fillExample()
  }
}

const fillExample = () => {
  // 不改城市，避免与已登录骑手城市错位
  form.strategy = 'free_pool'
  form.fee = form.bizType === 'errand_buy' ? 10 : 12
  form.etaMinutes = form.bizType === 'errand_buy' ? 50 : 40
  form.dropTitle = '用户住址'
  if (form.city === '南京') {
    form.dropAddr = '鼓楼区宁海路 20 号 3 栋 501'
    form.dropLat = 32.06
    form.dropLng = 118.77
    if (form.bizType === 'errand_buy') {
      form.pickTitle = '盒马鲜生（新街口）'
      form.pickAddr = '玄武区汉中路 xx 号'
      form.pickLat = 32.04
      form.pickLng = 118.78
      form.remark = '矿泉水 2 箱；纸巾 1 提；不要香菜'
    } else {
      form.pickTitle = '华联超市（新街口店）'
      form.pickAddr = '玄武区中山路 1 号'
      form.pickLat = 32.04
      form.pickLng = 118.78
      form.remark = '文件袋 1 份，勿压、勿折'
    }
  } else {
    form.dropAddr = '西湖区文一路 100 号'
    form.dropLat = 30.28
    form.dropLng = 120.16
    if (form.bizType === 'errand_buy') {
      form.pickTitle = '盒马鲜生（黄龙店）'
      form.pickAddr = '西湖区黄龙路 1 号'
      form.pickLat = 30.27
      form.pickLng = 120.15
      form.remark = '矿泉水 2 箱；纸巾 1 提；不要香菜'
    } else {
      form.pickTitle = '华联超市（文三路店）'
      form.pickAddr = '西湖区文三路 1 号'
      form.pickLat = 30.27
      form.pickLng = 120.15
      form.remark = '文件袋 1 份，勿压、勿折'
    }
  }
}

const goInspect = () => {
  router.push({ path: '/distribution/platform/waybill' })
}

const onCreate = async () => {
  if (form.strategy === 'org_dispatch' && !form.orgId) {
    ElMessage.warning('机构派单须填写机构 ID')
    return
  }
  if (isErrand.value && (!form.pickAddr?.trim() || !form.dropAddr?.trim())) {
    ElMessage.warning('跑腿单请填写取/购与送详细地址')
    return
  }
  submitting.value = true
  try {
    const res = await WaybillApi.mockCreateWaybill({ ...form })
    lastStrategy.value = form.strategy
    if (res.status === 'rejected') {
      ElMessage.error(res.rejectReason || '造单被拒绝')
    } else if (res.code === 'DUPLICATE_EXTERNAL_ID') {
      ElMessage.success(`幂等命中首单 ${res.waybillId} [${res.code}]`)
    } else {
      ElMessage.success(`已进单 ${res.waybillId}（已落库）`)
    }
    await loadList()
  } finally {
    submitting.value = false
  }
}

const loadList = async () => {
  const r = await WaybillApi.getWaybillList({
    pageNo: pageNo.value,
    pageSize: pageSize.value,
  })
  if (!disposed) {
    list.value = r?.list || []
    total.value = r?.total || 0
  }
}

onMounted(() => {
  loadList()
})

onBeforeUnmount(() => {
  disposed = true
})
</script>
